import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './TableRow.scss';
/**
 * @component TableRow
 * @since 1.0.0
 * @hidden
 */
export function TableRow(props) {
    const { style, onMouseEnter, onMouseLeave, onClick } = Object.assign({ style: 'normal' }, props);
    const className = classNames('table-row', 'table-row--' + style);
    return (React.createElement("tr", { className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick }, props.children));
}
